import moment from 'moment';

export const diferenciaHora = (horaInicial, seconds = false) => {
    const fechaI = moment(horaInicial);
    const fechaF = moment(new Date());

    const horas = fechaF.diff(fechaI, 'hours') < 10 ? `0${ fechaF.diff(fechaI, 'hours') }` : fechaF.diff(fechaI, 'hours');
    const minutos = moment.duration(fechaF.diff(fechaI)).minutes() < 10 ? `0${ moment.duration(fechaF.diff(fechaI)).minutes() }` : moment.duration(fechaF.diff(fechaI)).minutes();
    const segundos = moment.duration(fechaF.diff(fechaI)).seconds() < 10 ? `0${ moment.duration(fechaF.diff(fechaI)).seconds() }` : moment.duration(fechaF.diff(fechaI)).seconds();

    return seconds ? `${ horas }:${ minutos }:${ segundos }` : `${ horas }:${ minutos }`;
}

export const formatearFecha = (fecha) => {
    const dia = moment(fecha).date() < 10 ? `0${ moment(fecha).date() }` : moment(fecha).date();
    const mes = (moment(fecha).month() + 1) < 10 ? `0${ (moment(fecha).month() + 1) }` : (moment(fecha).month() + 1);
    const anio = moment(fecha).year();

    return `${ dia }/${ mes }/${ anio }`;
}

export const formatearHora = (fecha) => {
    return moment(fecha).format('LTS');
}

export const formatearTiempo = (tiempo) => {
    const { hours, minutes, seconds } = tiempo;
    const horas = hours < 10 ? `0${ hours }` : hours;
    const minutos = minutes < 10 ? `0${ minutes }` : minutes;
    const segundos = seconds < 10 ? `0${ seconds }` : seconds;

    return `${ horas }:${ minutos }:${ segundos }`;
}